import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum ZapBulkActionOptions {
  ChangeOwner = "change_owner",
  Move = "move",
  Export = "export",
  Delete = "delete",
}

interface EmitOptions {
  optionSelected: ZapBulkActionOptions;
  interactionRawText?: string;
}

export function useEmitZapBulkActionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, interactionRawText }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ZapBulkAction,
        interactionRawText,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
